

























































































































export default function (Component) {
  Component.options.__source = "src/components/d2-container-echarts-chaingroup-pie/index.vue"
}
